module.exports = __webpack_public_path__ + "media/PortafolioReel-movil.141cef52.mp4";